import {BaseComponentWithContext} from '@mintdata/mint-kit/api/components/BaseComponentWithContext';
import {IDisposable} from '@mintdata/mint-kit/api/resources/IDisposable';
import {IPopupGlassLayerProps, PopupGlassLayer} from '@mintdata/mint-kit/impl/components/popover/PopupGlassLayer';
import {PopupStackEvent} from '@mintdata/mint-kit/impl/components/popover/PopupManager';
import {PopupItem} from '@mintdata/mint-kit/impl/components/popover/PopupState';
import {bind} from 'bind-decorator';
import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('@mintdata/mint-kit/impl/components/popover/PopupGlassView.less');
const cx = classnames.bind(styles);

export interface IProps
{
    className?:string;
    modalBackgroundClassName?:string;
    onPopupStackChanged?:(openPopupsCount:number) => void
}

export class PopupGlassView extends BaseComponentWithContext<IProps, any>
{
    private _popupStackListener:IDisposable;

    @bind
    private _onPopupStackChanged(e:PopupStackEvent):void
    {
        const {onPopupStackChanged} = this.props;

        if( onPopupStackChanged )
            onPopupStackChanged(e.popupStack.length);

        this.forceUpdate();
    }

    public componentDidMount():void
    {
        const {popupManager} = this.context;

        this._popupStackListener = popupManager.onPopupStackChanged(this._onPopupStackChanged);
    }

    public componentWillUnmount():void
    {
        if( this._popupStackListener )
            this._popupStackListener.dispose();
    }

    private _areAnyItemsVisible():boolean
    {
        const {popupManager} = this.context;
        const popupStack = popupManager.getPopupStack();
        return popupStack && popupStack.length > 0;
    }

    private _hasModalsInStack():boolean
    {
        const {popupManager} = this.context;
        const popupStack = popupManager.getPopupStack();

        if( popupStack && popupStack.length > 0 )
            for( const popupItem of popupStack )
                if( popupItem.specProps.isModal )
                    return true;

        return false;
    }

    private _renderItemsLinear():Array<JSX.Element>
    {
        const {popupManager} = this.context;
        const popupStack = popupManager.getPopupStack();

        return popupStack.map((popupItem:PopupItem) =>
        {
            const {modalBackgroundClassName} = this.props;

            const props:IPopupGlassLayerProps = {
                popupItem
            };

            if( popupItem.specProps.hasModalBackground )
                props.modalBackgroundClassName = modalBackgroundClassName;

            return <PopupGlassLayer key={popupItem.id} {...props} />;
        });
    }

    public render():JSX.Element
    {
        // Return early such that 'styles.glassRootBackground' is not drawn
        // if no popups are currently visible
        if( !this._areAnyItemsVisible() )
            return null;

        const {className} = this.props;

        return (
            <div id={'popupGlassView'}
                 className={cx('glassRootBackground', {hasModals: this._hasModalsInStack()}, className)}
            >
                {this._renderItemsLinear()}
            </div>
        );
    }
}
